import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type ProgressVariant = 'primary' | 'success' | 'warning' | 'danger';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-progress-bar',
  styleUrl: './progress-bar.scss',
  templateUrl: './progress-bar.html',
})
export class ProgressBarComponent {
  /** Progression en pourcentage (0-100). */
  readonly value = input(0);

  /** Variante de couleur. */
  readonly variant = input<ProgressVariant>('primary');

  /** Affiche le pourcentage sous forme de texte. */
  readonly showLabel = input(false);

  /** Hauteur de la barre (px). */
  readonly height = input(8);

  protected readonly clamped = computed(() =>
    Math.min(100, Math.max(0, this.value())),
  );
}
